jQuery(document).ready(function($) {
    console.log('jQuery is ready');
});